export default "__VITE_ASSET__RWgRhJoX__"